import api from './api';

export const bulkBooksService = {
  // Get preview of popular books available for import
  getPopularBooksPreview: async () => {
    try {
      const response = await api.get('/bulk-books/popular-books-preview');
      return response.data;
    } catch (error) {
      console.error('Error fetching popular books preview:', error);
      throw error;
    }
  },

  // Import popular books
  importPopularBooks: async (limit = 50, genreFilter = null) => {
    try {
      const params = { limit };
      if (genreFilter) {
        params.genre_filter = genreFilter;
      }
      
      const response = await api.post('/bulk-books/import-popular-books', {}, { params });
      return response.data;
    } catch (error) {
      console.error('Error importing popular books:', error);
      throw error;
    }
  },

  // Get import statistics
  getImportStats: async () => {
    try {
      const response = await api.get('/bulk-books/import-stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching import stats:', error);
      throw error;
    }
  }
};